import { render } from "./agile.vue?vue&type=template&id=c582456c&scoped=true"
import script from "./agile.vue?vue&type=script&lang=js"
export * from "./agile.vue?vue&type=script&lang=js"

import "./agile.vue?vue&type=style&index=0&id=c582456c&lang=less&scoped=true"
/* hot reload */
if (module.hot) {
  script.__hmrId = "c582456c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c582456c', script)) {
    api.reload('c582456c', script)
  }
  
  module.hot.accept("./agile.vue?vue&type=template&id=c582456c&scoped=true", () => {
    api.rerender('c582456c', render)
  })

}


import exportComponent from "D:\\develop\\simo\\front\\website\\front-bc-huibentong-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c582456c"],['__file',"src/views/index/pages/agile.vue"]])